import { useEffect, useRef, useState } from "react";

// Monte ses enfants uniquement lorsqu'ils approchent du viewport.
// Diffère ainsi les appels IA (fetch au montage) jusqu'à ce que la section soit proche de l'écran.
export function LazyMount({ children, minHeight = 480, rootMargin = "400px", testId, id }) {
  const ref = useRef(null);
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (show) return;
    const el = ref.current;
    if (!el) return;
    if (typeof IntersectionObserver === "undefined") {
      setShow(true);
      return;
    }
    const io = new IntersectionObserver(
      (entries) => {
        if (entries.some((e) => e.isIntersecting)) {
          setShow(true);
          io.disconnect();
        }
      },
      { rootMargin }
    );
    io.observe(el);
    return () => io.disconnect();
  }, [show, rootMargin]);

  return (
    <div ref={ref} id={id} data-testid={testId} style={{ scrollMarginTop: "80px" }}>
      {show ? children : <div style={{ minHeight }} aria-hidden />}
    </div>
  );
}
